import { HeaderGroup } from "@tanstack/react-table";
import { Virtualizer } from "@tanstack/react-virtual";

import { TableMetaProps } from "@/hooks/table/useTableConfig";
import TableHeaderCell from "@/components/molecules/table/TableHeaderCell";
import { VirtualTablePaddings } from "@/components/organisms/table/table.utils";

export type TableHeaderRowProps<T> = {
  headerGroup: HeaderGroup<T>;
  canReorderColumns: boolean;
  columnVirtualizer: Virtualizer<HTMLDivElement, Element>;
  virtualPaddings: VirtualTablePaddings;
};

const TableHeaderRow = <T,>({
  headerGroup,
  canReorderColumns,
  columnVirtualizer,
  virtualPaddings,
}: TableHeaderRowProps<T>) => {
  if (headerGroup.headers.length === 0) return null;
  const firstStickyColumn = headerGroup.headers[0];

  return (
    <tr className={"flex w-full"}>
      <TableHeaderCell
        key={`column-${firstStickyColumn.id}`}
        header={firstStickyColumn}
        index={0}
        canReorderColumns={false}
      />

      {virtualPaddings.left ? <th className={"flex"} style={{ width: virtualPaddings.left }} /> : null}

      {columnVirtualizer
        .getVirtualItems()
        .slice(1)
        .map((virtualColumn) => {
          const header = headerGroup.headers[virtualColumn.index];

          const meta: TableMetaProps = header.column.columnDef.meta || {};
          const canReorder = !meta?.disableReorder && canReorderColumns;

          return (
            <TableHeaderCell
              key={`column-${header.id}`}
              header={header}
              index={virtualColumn.index}
              canReorderColumns={canReorder}
            />
          );
        })}

      {virtualPaddings.right ? <th className={"flex"} style={{ width: virtualPaddings.right }} /> : null}
    </tr>
  );
};

export default TableHeaderRow;
